import { env } from "@/env";
import { redirectToSignIn } from "@/lib/auth";
import { MerchantSchema } from "@/types/merchant";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { getRouteApi } from "@tanstack/react-router";

export function getMerchantQuery({
  accessToken,
  merchantId,
}: {
  accessToken: string;
  merchantId: string;
}) {
  const merchantQuery = queryOptions({
    queryKey: ["merchant-new", merchantId],
    // Always keep merchant data until the user reloads the page
    // At some point move this out of here and use a global state store thats not router context
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: "always",
    queryFn: async () => {
      const response = await fetch(
        `${env.VITE_VOLUME_URL}/api/merchants/${merchantId}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );

      if (response.status === 401 || response.status === 403) {
        throw redirectToSignIn(false);
      }

      if (!response.ok) {
        throw new Error("Failed to fetch merchant details");
      }
      const json = await response.json();
      const merchantData = MerchantSchema.parse(json);

      return merchantData;
    },
  });
  return merchantQuery;
}

const mainLayoutRoute = getRouteApi("/(app)/_main-layout");
export function useMerchant() {
  const context = mainLayoutRoute.useRouteContext();
  const merchant = useSuspenseQuery(
    getMerchantQuery({
      accessToken: context.accessToken,
      merchantId: context.merchantId,
    }),
  );

  return merchant.data;
}
